export const boxShadows = {
  modal: "0px -5px 28px rgba(0, 0, 0, 0.05)",
  card: "0px 28px 32px -20px rgba(23, 23, 47, 0.08)",
  soft: "0px 20px 80px rgba(0, 0, 0, 0.06)",
  soft2: "0px 16.8421px 67.3684px rgba(0, 0, 0, 0.06)",
} as const;
